export default {
  burgerMenuState: false,
  currenciesSign: '€',
  zIndexBlock: '',
  packages: [],
  packagesLoading: true,
  activeHeaderSection: null,
}
